module.exports = __webpack_public_path__ + "img/title-1.a6232c5a.png";